import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import lists from './lists';

const Zones = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/list`} component={lists}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Zones;
